import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let blank = {
    component: {
        render(c) {
            return c("router-view");
        }
    }
};

function configRoutes() {
    return [
        {
            path: "/",
            redirect: "/login",
            name: "Home",
            component: () => import("@/containers/DefaultContainer"),
            meta: { hideInBreadcrumb: true },
            children: [
                {
                    path: "dashboard",
                    name: "Dashboard",
                    component: () => import("@/views/Dashboard")
                },
                {
                    path: "tableau",
                    name: "Tableau",
                    component: () => import("@/views/Tableau")
                },
                {
                    path: "master",
                    name: "Master",
                    redirect: "/master/barang",
                    ...blank,
                    children: [
                        {
                            path: "aksesoris",
                            name: "Aksesoris",
                            component: () =>
                                import("@/views/master/aksesoris/ListAksesoris")
                        },
                        {
                            path: "barang",
                            name: "Barang",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/master/barang/ListBarang")
                                },
                                {
                                    path: ":segment/:id",
                                    name: "Edit Barang",
                                    component: () =>
                                        import("@/views/master/barang/EditBarang")
                                }
                            ]
                        },
                        {
                            path: "harga-emas",
                            name: "Harga Emas",
                            component: () =>
                                import("@/views/master/harga-emas/ListHargaEmas")
                        },
                        {
                            path: "rumus-umum-grade",
                            name: "Rumus Umum Grade",
                            component: () =>
                                import("@/views/master/rumus-umum-grade/RumusUmumGrade")
                        },
                        {
                            path: "adjustment-harga-gudang",
                            name: "Adjustment Harga Gudang",
                            component: () =>
                                import("@/views/master/adjustment-harga-gudang/AdjustmentHargaGudang")
                        },
                        {
                            path: "adjustment-harga-batangan",
                            name: "Adjustment Harga Batangan",
                            component: () =>
                                import("@/views/master/adjustment-harga-batangan/AdjustmentHargaBatangan")
                        },
                        {
                            path: "kategori-kerusakan",
                            name: "Kategori Kerusakan",
                            component: () =>
                                import("@/views/master/kategori-kerusakan/KategoriKerusakan")
                        },
                        {
                            path: "adjustment-kerusakan",
                            name: "Adjustment Kerusakan",
                            component: () =>
                                import("@/views/master/adjustment-kerusakan/AdjustmentKerusakan")
                        },
                        {
                            path: "gudang",
                            name: "Gudang",
                            component: () =>
                                import("@/views/master/gudang/ListGudang")
                        },
                        {
                            path: "spek",
                            name: "Spek Barang",
                            component: () =>
                                import("@/views/master/spek/ListSpek")
                        },
                        {
                            path: "warna",
                            name: "Warna Barang",
                            component: () =>
                                import("@/views/master/warna/ListWarna")
                        },
                        {
                            path: "kategori-foto",
                            name: "Kategori Foto",
                            component: () =>
                                import("@/views/master/kategori-foto/KategoriFoto")
                        },
                        {
                            path: "marketplace-fee",
                            name: "Biaya Marketplace",
                            component: () =>
                                import("@/views/master/marketplace-fee/ListMarketplaceFee")
                        },
                        {
                            path: "rumus-harga-marketplace",
                            name: "Rumus Harga Marketplace",
                            component: () =>
                                import("@/views/master/rumus-harga-marketplace/ListRumusHargaMarketplace")
                        },
                        {
                            path: "pph",
                            name: "PPH",
                            component: () =>
                                import("@/views/master/pph/ListPph")
                        },
                        {
                            path: "materai",
                            name: "Materai",
                            component: () =>
                                import("@/views/master/materai/ListMaterai")
                        }
                    ]
                },
                {
                    path: "inventory",
                    name: "Inventory",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/inventory/ListInventory")
                        },
                        {
                            path: "edit/:id",
                            name: "Edit Inventory",
                            component: () =>
                                import("@/views/inventory/EditInventory")
                        }
                    ]
                },
                {
                    path: "inventory-pending",
                    name: "Inventory Pending",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/inventory-pending/ListInventoryPending")
                        }
                    ]
                },
                {
                    path: "history-foto-video",
                    name: "History Foto / Video",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/history-foto-video/ListHistory")
                        }
                    ]
                },
                {
                    path: "pindah-gudang",
                    name: "Pindah Gudang",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/pindah-barang/ListPindahBarang")
                        },
                        {
                            path: "draft/:id",
                            name: "Draft Pindah Gudang",
                            component: () =>
                                import("@/views/pindah-barang/DraftPindahBarang")
                        },
                        {
                            path: ":id",
                            name: "Detail Pindah Gudang",
                            component: () =>
                                import("@/views/pindah-barang/DetailPindahBarang")
                        }
                    ]
                },
                {
                    path: "barang-masuk",
                    name: "Barang Masuk",
                    ...blank,
                    children: [
                        {
                            path: "list",
                            component: () =>
                                import("@/views/barang-masuk/ListPengiriman")
                        },
                        {
                            path: "input",
                            name: "Input Barang Masuk",
                            component: () =>
                                import("@/views/barang-masuk/InputBarangMasuk")
                        },
                        {
                            path: "input-emas",
                            name: "Input Barang Masuk",
                            component: () =>
                                import("@/views/barang-masuk/InputBarangMasukEmas")
                        },
                        {
                            path: "approve",
                            name: "Approve Barang Masuk",
                            component: () =>
                                import("@/views/barang-masuk/ListPengiriman")
                        },
                        {
                            path: "upload-v2",
                            name: "Upload Foto / Video V2",
                            component: () =>
                                import("@/views/barang-masuk/UploadV2")
                        },
                        {
                            path: "input-accesoris",
                            name: "Approve Aksesoris",
                            component: () =>
                                import("@/views/barang-masuk/InputAcc")
                        },
                        {
                            path: "titip-jual",
                            name: "List Titip Jual PGI",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/barang-masuk/ListTitipJual")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Titip Jual PGI",
                                    component: () =>
                                        import("@/views/barang-masuk/DetailTitipJual")
                                }
                            ]
                        },
                        {
                            path: ":deliveryId",
                            name: "Batch Barang Masuk",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/barang-masuk/ListBatch")
                                },
                                {
                                    path: ":batchId",
                                    name: "List Barang",
                                    component: () =>
                                        import("@/views/barang-masuk/ListBarangMasuk")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "sales",
                    name: "Penjualan",
                    ...blank,
                    children: [
                        {
                            path: "customer",
                            name: "Customer",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/sales/customer/ListCustomer")
                                }
                                // {
                                //     path: 'payment/:id',
                                //     name: "Pembayaran Piutang Customer",
                                //     component: () => import('@/views/sales/customer/Payment')
                                // }
                            ]
                        },
                        {
                            path: "invoice",
                            name: "Invoice",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/sales/invoice/ListInvoice")
                                },
                                {
                                    path: "draft/:id",
                                    name: "Draft Invoice",
                                    component: () =>
                                        import("@/views/sales/invoice/DraftInvoice")
                                },
                                {
                                    path: "draft-gold/:id",
                                    name: "Draft Invoice Emas",
                                    component: () =>
                                        import("@/views/sales/invoice/DraftInvoiceGold")
                                },
                                {
                                    path: "payments/:id",
                                    name: "Invoice Payments",
                                    component: () =>
                                        import("@/views/sales/invoice/PaymentInvoice")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Invoice",
                                    component: () =>
                                        import("@/views/sales/invoice/DetailInvoice")
                                },
                                {
                                    path: "gold/:id",
                                    name: "Detail Invoice Emas",
                                    component: () =>
                                        import("@/views/sales/invoice/DetailInvoiceGold")
                                }
                            ]
                        },
                        {
                            path: "request-void",
                            name: "Daftar Request Void",
                            component: () =>
                                import("@/views/sales/invoice/ListRequestInvoice")
                        },
                        {
                            path: "retur",
                            name: "Daftar Retur",
                            component: () =>
                                import("@/views/sales/retur/ListRetur")
                        },
                        {
                            path: "transactions",
                            name: "Daftar Transaksi",
                            component: () =>
                                import("@/views/sales/transactions/ListTransaction")
                        },
                        {
                            path: "retur-request",
                            name: "Daftar Retur Request",
                            component: () =>
                                import("@/views/sales/retur-request/ListReturRequest")
                        },
                        {
                            path: "point-transactions",
                            name: "Daftar Transaksi Poin",
                            component: () =>
                                import("@/views/sales/point-transactions/ListPointTransaction")
                        },
                        {
                            path: "overlimit-request",
                            name: "Daftar Overlimit Request",
                            component: () =>
                                import("@/views/sales/overlimit-request/ListOverlimitRequest")
                        },
                        {
                            path: "flash-sale",
                            name: "Flash Sale",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/sales/flash-sale/ListFlashSale")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Flash Sale",
                                    component: () =>
                                        import("@/views/sales/flash-sale/DetailFlashSale")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "marketplace",
                    name: "Marketplace",
                    redirect: "/marketplace/list",
                    ...blank,
                    children: [
                        {
                            path: "list",
                            name: "Penjualan Marketplace",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/marketplace/ListMarketplace")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Marketplace",
                                    component: () =>
                                        import("@/views/marketplace/DetailMarketplace")
                                }
                            ]
                        },
                        {
                            path: "returns",
                            name: "Retur Marketplace",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/marketplace/ListReturMarketplace")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Retur Marketplace",
                                    component: () =>
                                        import("@/views/marketplace/DetailReturMarketplace")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "adjustment-barcode",
                    name: "Adjustment Barcode",
                    component: () =>
                        import("@/views/adjustment-barcode/ListAdjustmentBarcode")
                },
                {
                    path: "log-barcode",
                    name: "Log Barcode",
                    component: () =>
                        import("@/views/log-barcode/ListLogBarcode")
                },
                {
                    path: "kirim-balik",
                    name: "Kirim Balik PGI",
                    ...blank,
                    children: [
                        {
                            path: "item",
                            name: "Return Item",
                            component: () =>
                                import("@/views/kirim-balik/ListKirimBalik")
                        },
                        {
                            path: "invoice",
                            name: "Invoice Pengembalian",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/kirim-balik/ListInvoiceKirimBalik")
                                },
                                {
                                    path: "draft/:id",
                                    component: () =>
                                        import("@/views/kirim-balik/DraftInvoiceKirimBalik")
                                },
                                {
                                    path: ":id",
                                    component: () =>
                                        import("@/views/kirim-balik/DetailInvoiceKirimBalik")
                                }
                            ]
                        },
                        {
                            path: "cancel-item",
                            name: "Cancel Return Item",
                            component: () =>
                                import("@/views/kirim-balik/ListCancelKirimBalik")
                        },
                        {
                            path: "cancel-invoice",
                            name: "Invoice Cancel Pengembalian",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/kirim-balik/ListInvoiceCancelKirimBalik")
                                },
                                {
                                    path: "draft/:id",
                                    component: () =>
                                        import("@/views/kirim-balik/DraftInvoiceCancelKirimBalik")
                                },
                                {
                                    path: ":id",
                                    component: () =>
                                        import("@/views/kirim-balik/DetailInvoiceCancelKirimBalik")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "kirim-inven",
                    name: "Kirim Invent",
                    ...blank,
                    children: [
                        {
                            path: "list",
                            component: () =>
                                import("@/views/kirim-inven-pgi/ListKirimInven")
                        },
                        {
                            path: "draft/:id",
                            name: "Draft Kirim Invent",
                            component: () =>
                                import("@/views/kirim-inven-pgi/DraftKirimInven")
                        },
                        {
                            path: "request",
                            name: "Request Kirim Invent",
                            component: () =>
                                import("@/views/kirim-inven-pgi/ListRequestInven")
                        },
                        {
                            path: "list/:id",
                            name: "Detail Kirim Invent",
                            component: () =>
                                import("@/views/kirim-inven-pgi/DetailKirimInven")
                        },
                        {
                            path: "retur",
                            name: "Retur Kirim Invent",
                            component: () =>
                                import("@/views/kirim-inven-pgi/ListReturKirimInven")
                        },
                        {
                            path: "retur/:id",
                            name: "Detail Retur Kirim Invent",
                            component: () =>
                                import("@/views/kirim-inven-pgi/DetailReturKirimInven")
                        },
                        {
                            path: "retur/draft/:id",
                            name: "Draft Retur Kirim Invent",
                            component: () =>
                                import("@/views/kirim-inven-pgi/DraftReturKirimInvent")
                        }
                    ]
                },
                {
                    path: "inventory-reset",
                    name: "Inventory Reset",
                    component: () =>
                        import("@/views/inventory-reset/ListInventoryReset")
                },
                {
                    path: "inventory-temuan",
                    name: "Temuan Inventaris",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/temuan-inventory/ListTemuanInventory")
                        },
                        {
                            path: ":id",
                            name: "Detail Temuan Inventaris",
                            component: () =>
                                import("@/views/temuan-inventory/DetailTemuanInventory")
                        }
                    ]
                },
                {
                    path: "inventory-report",
                    name: "Inventory Report",
                    component: () =>
                        import("@/views/inventory/ListInventoryReport")
                },
                {
                    path: "shopping-cart",
                    name: "Shopping Cart",
                    ...blank,
                    children: [
                        {
                            path: "",
                            component: () =>
                                import("@/views/shopping-cart/ListShoppingCart")
                        },
                        {
                            path: ":id",
                            name: "Detail Shopping Cart",
                            component: () =>
                                import("@/views/shopping-cart/DetailShoppingCart")
                        }
                    ]
                },
                {
                    path: "emas",
                    name: "Emas",
                    ...blank,
                    children: [
                        {
                            path: "inventory",
                            component: () =>
                                import("@/views/inventory-emas/ListInventory")
                        },
                        {
                            path: "terima",
                            name: "Terima Emas",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/terima-emas-pei/ListBox")
                                },
                                {
                                    path: "approval-emas",
                                    name: "Approval Emas",
                                    component: () =>
                                        import("@/views/terima-emas-pei/ApprovalEmas")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Box",
                                    component: () =>
                                        import("@/views/terima-emas-pei/DetailBox")
                                }
                            ]
                        },
                        {
                            path: "pengiriman",
                            name: "Pengiriman Emas",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/pengiriman-pei/ListDelivery")
                                },
                                {
                                    path: ":deliveryId",
                                    name: "Batch Emas",
                                    ...blank,
                                    children: [
                                        {
                                            path: "",
                                            component: () =>
                                                import("@/views/pengiriman-pei/ListBatch")
                                        },
                                        {
                                            path: ":batchId",
                                            name: "Box Emas",
                                            ...blank,
                                            children: [
                                                {
                                                    path: "",
                                                    component: () =>
                                                        import("@/views/pengiriman-pei/ListBox")
                                                },
                                                {
                                                    path: ":id",
                                                    name: "Detail Box",
                                                    component: () =>
                                                        import("@/views/pengiriman-pei/DetailBox")
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: "temuan",
                            name: "Temuan Emas",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/temuan-emas/ListTemuanEmas")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Temuan Emas",
                                    component: () =>
                                        import("@/views/temuan-emas/DetailTemuanEmas")
                                }
                            ]
                        },
                        {
                            path: "gold-batches",
                            name: "Lebur & Pemurnian Emas",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/gold-batches/ListGoldBatches")
                                },
                                {
                                    path: "draft/:id",
                                    name: "Draft Gold Batch",
                                    component: () =>
                                        import("@/views/gold-batches/DraftGoldBatch")
                                },
                                {
                                    path: ":id",
                                    name: "Detail Gold Batch",
                                    component: () =>
                                        import("@/views/gold-batches/DetailGoldBatch")
                                }
                            ]
                        },
                        {
                            path: "edit-emas",
                            name: "Request Edit Emas",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    component: () =>
                                        import("@/views/edit-emas/ListEditEmas")
                                },
                                {
                                    path: ":id",
                                    component: () =>
                                        import("@/views/edit-emas/DetailEditEmas")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "laporan",
                    name: "Laporan",
                    component: () => import("@/views/laporan/Laporan")
                },
                {
                    path: "laporan-3-bulan",
                    name: "Laporan 3 Bulanan",
                    component: () =>
                        import("@/views/laporan-3-bulan/Laporan3Bulan")
                },
                {
                    path: "admin",
                    name: "Administrasi",
                    ...blank,
                    children: [
                        {
                            path: "user",
                            name: "User",
                            component: () =>
                                import("@/views/administrasi/user/ListUser")
                        },
                        {
                            path: "role",
                            name: "Role",
                            component: () =>
                                import("@/views/administrasi/role/ListRole")
                        },
                        {
                            path: "divisi",
                            name: "Divisi",
                            component: () =>
                                import("@/views/administrasi/divisi/ListDivisi")
                        }
                    ]
                },
                {
                    path: "tv-commercial",
                    name: "TV Commercial",
                    ...blank,
                    children: [
                        {
                            path: "",
                            name: "TV Commercial Group",
                            component: () =>
                                import("@/views/tv-commercial/ListTvGroups")
                        },
                        {
                            path: ":id",
                            name: "TV Commercial Item",
                            component: () =>
                                import("@/views/tv-commercial/ListTvItems")
                        }
                    ]
                },
                {
                    path: "konser-penjualan",
                    name: "Konser Penjualan",
                    ...blank,
                    children: [
                        {
                            path: "",
                            redirect: "konser"
                        },
                        {
                            path: "konser",
                            name: "Daftar Konser",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    name: "",
                                    component: () =>
                                        import("@/views/konser-penjualan/daftar-konser/ListKonserPenjualan")
                                },
                                {
                                    path: ":id/submissions",
                                    name: "Daftar Peserta",
                                    component: () =>
                                        import("@/views/konser-penjualan/daftar-konser/ListSubmission")
                                }
                            ]
                        },
                        {
                            path: "deposit",
                            name: "Deposit Konser",
                            ...blank,
                            children: [
                                {
                                    path: "",
                                    name: "",
                                    component: () =>
                                        import("@/views/konser-penjualan/deposit-konser/ListDepositKonser")
                                },
                                {
                                    path: "submission/:id",
                                    name: "Detail Peserta",
                                    component: () =>
                                        import("@/views/konser-penjualan/daftar-konser/DetailSubmission")
                                }
                            ]
                        },
                        {
                            path: "refund",
                            name: "Refund Konser",
                            component: () =>
                                import("@/views/konser-penjualan/refund-konser/ListRefundKonser")
                        }
                    ]
                }
            ]
        },
        {
            path: "/login",
            name: "Login",
            component: () => import("@/views/Login")
        }
        // {
        //     // path: '/katalog/detail',
        //     path: '/katalog/:id',
        //     name: 'Detail Katalog',
        //     component: () => import('@/views/KatalogDetail')
        // },
        // {
        //     path: '/katalog',
        //     name: 'Katalog',
        //     component: () => import('@/views/Katalog')
        // }
    ];
}

export default new Router({
    mode: "history",
    linkActiveClass: "open active",
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
});
